import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addFamily, addIngredient, deleteFamily, deleteIngredient, getFamily } from '../Redux/Actions/IngredientVActions';
import './IngredientForm.css';

function IngredientFormV() {
  const dispatch = useDispatch();

  // Accéder aux familles depuis le store Redux
  const families = useSelector((state) => state.IngredientVReducer?.families || []);
  console.log('Families from Redux:', families);

  // États locaux
  const [newFamily, setNewFamily] = useState('');
  const [selectedFamily, setSelectedFamily] = useState('');
  const [selectedIngredient, setSelectedIngredient] = useState('');
  const [newIngredient, setNewIngredient] = useState('');
  const [price, setPrice] = useState('');
  const [updateDate, setUpdateDate] = useState('');

  useEffect(() => {
    console.log('Dispatching getFamily');
    dispatch(getFamily());
  }, [dispatch]);

  useEffect(() => {
    console.log('Families from Redux in IngredientForm:', families);
  }, [families]);

  // Ajouter une nouvelle famille
  const addFamilyHandler = async () => {
    if (newFamily.trim()) {
      await dispatch(addFamily(newFamily)); // Ajouter la famille
      await dispatch(getFamily()); // Recharger les familles depuis le backend
      setNewFamily(''); // Réinitialiser le champ d'entrée
    }
  };

  // Ajouter un ingrédient à une famille
  const addIngredientHandler = async () => {
  if (selectedFamily && newIngredient.trim()) {
    await dispatch(addIngredient(selectedFamily, newIngredient));
    await dispatch(getFamily()); // Recharger les familles
    setNewIngredient('');
  }
};


  // Supprimer une famille
  const removeFamilyHandler = async () => {
    if (selectedFamily) {
      await dispatch(deleteFamily(selectedFamily));
      await dispatch(getFamily()); // Recharger les familles
      setSelectedFamily('');
    }
  };

  // Supprimer un ingrédient
  const removeIngredientHandler = async () => {
    if (selectedFamily && selectedIngredient) {
      await dispatch(deleteIngredient(selectedFamily, selectedIngredient));
      await dispatch(getFamily()); // Recharger les familles
      setSelectedIngredient('');
    }
  };

  // Gestion du formulaire de soumission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Famille:', selectedFamily);
    console.log('Ingrédient:', selectedIngredient);
    console.log('Prix d\'achat:', price);
    console.log('Date de mise à jour:', updateDate);
  };

  return (

    <div className="ingredient-container">

    <form className="ingredient-form" onSubmit={handleSubmit}>


      

      {/* Sélection de la famille */}
      <div className="col">
      <div className="form-group">
        <label>Famille :</label>
        <select value={selectedFamily} onChange={(e) => setSelectedFamily(e.target.value)}>
          <option value="">-- Sélectionnez une famille --</option>
          {families.map((family) => (
            <option key={family._id} value={family.name}>
              {family.name}
            </option>
          ))}
        </select>
      </div>

      {/* Ajout d'une nouvelle famille */}
      <div className="form-group actions-group">
        <input
          type="text"
          value={newFamily}
          onChange={(e) => setNewFamily(e.target.value)}
          placeholder="Nouvelle famille"
        />
        <button type="button" onClick={addFamilyHandler}>
          Ajouter famille
        </button>
        <button type="button" onClick={removeFamilyHandler} disabled={!selectedFamily}>
          Supprimer famille
        </button>
      </div>
      </div>
      {/* Sélection d'un ingrédient */}
      <div className="col">
      <div className="form-group">
        <label>Ingrédient :</label>
        <select
          value={selectedIngredient}
          onChange={(e) => setSelectedIngredient(e.target.value)}
          disabled={!selectedFamily}
        >
          <option value="">-- Sélectionnez un ingrédient --</option>
          {selectedFamily &&
            families
              .find((family) => family.name === selectedFamily)
              ?.ingredients.map((ingredient) => (
                <option key={ingredient._id} value={ingredient.name}>
                  {ingredient.name}
                </option>
              ))}
        </select>
        
      </div>

      {/* Ajout/Suppression d'ingrédients */}
      <div className="form-group actions-group">
        <input
          type="text"
          value={newIngredient}
          onChange={(e) => setNewIngredient(e.target.value)}
          placeholder="Nouvel ingrédient"
          disabled={!selectedFamily}
        />
        <button type="button" onClick={addIngredientHandler} disabled={!selectedFamily}>
          Ajouter ingrédient
        </button>
        <button
          type="button"
          onClick={removeIngredientHandler}
          disabled={!selectedFamily || !selectedIngredient}
        >
          Supprimer ingrédient
        </button>
      </div>

      {/* Saisie du prix et de la date
      <div className="form-group">
        <label>Prix d'achat :</label>
        <input
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="Prix en DT"
        />
      </div> */}

      {/* <div className="form-group">
        <label>Date de mise à jour :</label>
        <input
          type="date"
          value={updateDate}
          onChange={(e) => setUpdateDate(e.target.value)}
        />
      </div> */}
      </div>
      <button className="submit-button" type="submit">
        Valider
      </button>
    </form>
    </div>
  );
}

export default IngredientFormV;
